import { ReactElement } from "react";

const RadarChartTick: (props: any) => ReactElement<SVGElement> = ({
  x,
  y,
  payload,
  textAnchor,
  color,
  fontSize = 12,
  fontFamily = "Telegraf",
  offset = 10,
}) => {
  const rawValue = payload?.value;
  const label = typeof rawValue === "string" ? rawValue : String(rawValue ?? "");
  const values = label.split(" ");

  // use degree value to calculate the dy dx offset for each label
  const angle = (payload.coordinate * Math.PI) / 180;
  const dx = offset * Math.cos(angle);
  const dy = -offset * Math.sin(angle);

  const textLineHeight = fontSize;

  return (
    <g transform={`translate(${x + dx},${y + dy})`}>
      <text x={0} y={0} style={{ fontSize: fontSize, fontFamily: fontFamily, fontWeight: 600 }} fill={color} textAnchor={textAnchor}>
        {values.map((value: string, index: number) => (
          <tspan key={index} x="0" y={0} dy={index * textLineHeight} dx={dx} textAnchor={"middle"}>
            {value}
          </tspan>
        ))}
      </text>
    </g>
  );
};

export default RadarChartTick;
